import { mapToRecommendations } from './utils';
import { addAbsolutePosition } from './utils/addAbsolutePosition';
import { addIndexName } from './utils/addIndexName';
import { version } from './version';
export function getRelatedProducts({
  objectIDs,
  recommendClient,
  transformItems = x => x,
  fallbackParameters,
  indexName,
  maxRecommendations,
  queryParameters,
  threshold
}) {
  const queries = objectIDs.map(objectID => ({
    fallbackParameters,
    indexName,
    maxRecommendations,
    objectID,
    queryParameters,
    threshold
  }));
  recommendClient.addAlgoliaAgent('recommend-core', version);
  if (queries.length === 0) {
    return Promise.resolve({
      recommendations: []
    });
  }
  return recommendClient.getRelatedProducts(queries).then(response => mapToRecommendations({
    maxRecommendations,
    hits: response.results.map(result => result.hits),
    queryIDs: response.results.map(result => result.queryID),
    nrOfObjs: objectIDs.length
  })).then(hits => hits.map(hit => addIndexName(hit, indexName)).map((hit, idx) => addAbsolutePosition(hit, idx))).then(hits => ({
    recommendations: transformItems(hits)
  }));
}